import { Grid, Typography } from "@mui/material"

const VerificationSuccess = () => {
  return <Grid container sx={{minHeight: '300px'}}>
    <Grid item sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', textAlign: 'center', flexDirection: 'column'}}>
      <Typography sx={{fontWeight: 'bold', fontSize: '16px', color: '#003187'}}>Thanks for completing your order verification.</Typography>
      <Typography sx={{mt: 1, fontSize: '15px'}}>Your order has been successfully verified and is now being processed<br/>for service provisioning. You'll receive a confirmation email shortly.</Typography>
    </Grid>
  </Grid>
}

export default VerificationSuccess
